/**
 * Build and download a simple ICS calendar file for a booking.
 *
 * @param {{
 *   title: string,
 *   startsAt: string,
 *   endsAt?: string,
 *   location?: string,
 *   description?: string,
 *   uid?: string,
 * }} params
 */
export function downloadBookingIcs({ title, startsAt, endsAt, location = '', description = '', uid }) {
  const start = toIcsDate(startsAt)
  const end = toIcsDate(endsAt ?? addMinutes(startsAt, 60))
  const eventUid = uid ?? `booking-${Date.now()}@saloon-erp`

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Salon ERP//Online Booking//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${escapeIcs(eventUid)}`,
    `DTSTAMP:${toIcsDate(new Date().toISOString())}`,
    `DTSTART:${start}`,
    `DTEND:${end}`,
    `SUMMARY:${escapeIcs(title)}`,
    location ? `LOCATION:${escapeIcs(location)}` : null,
    description ? `DESCRIPTION:${escapeIcs(description)}` : null,
    'END:VEVENT',
    'END:VCALENDAR',
  ].filter(Boolean)

  const blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'appointment.ics'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

function toIcsDate(value) {
  const date = new Date(value)
  const pad = (n) => String(n).padStart(2, '0')

  return [
    date.getUTCFullYear(),
    pad(date.getUTCMonth() + 1),
    pad(date.getUTCDate()),
    'T',
    pad(date.getUTCHours()),
    pad(date.getUTCMinutes()),
    pad(date.getUTCSeconds()),
    'Z',
  ].join('')
}

function addMinutes(iso, minutes) {
  const date = new Date(iso)
  date.setMinutes(date.getMinutes() + minutes)
  return date.toISOString()
}

function escapeIcs(value) {
  return String(value)
    .replace(/\\/g, '\\\\')
    .replace(/\n/g, '\\n')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;')
}
